import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './Inventories.slice'
import { paginate } from './Inventories.thunk'
import { act } from 'react-dom/test-utils'

function paginateInventories () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateInventories),
    takeLatest(actions.replacePage, paginateInventories),
    takeLatest(actions.replaceSearch, paginateInventories),
    takeLatest(actions.replaceStatus, paginateInventories),
    takeLatest(actions.replaceFilter, paginateInventories),
    takeLatest(actions.replaceSelectedItem, paginateInventories),
    takeLatest(actions.replaceSelectedWorkOrder, paginateInventories),
    takeLatest(actions.replaceLPN, paginateInventories),
    takeLatest(actions.replaceAllFilters, paginateInventories)
  ])
}
